import BackgroundPattern from './partials/BackgroundPattern';

const PublicLayout = ({ children }) => (
	<div className="relative overflow-hidden bg-oly-gray-lightestAlpha45">
		<BackgroundPattern color="text-oly-gray-lightest" />
		<div className="relative min-h-screen">
			{children}
		</div>
	</div>
);

export default PublicLayout;
